import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./assest/css/style.css"
import "./assest/js/main.js"
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
    <App />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals 
    document.addEventListener('DOMContentLoaded', function () {
      const counters = document.querySelectorAll('.count');
      let started = false;

      function animateCountUp(el, target, duration) {
        let start = 0;
        const increment = target / (duration / 10);
        const interval = setInterval(() => {
          start += increment;
          if (start >= target) {
            el.textContent = target + '+';
            clearInterval(interval);
          } else {
            el.textContent = Math.ceil(start);
          }
        }, 10);
      }

      function startCounters() {
        if (started) return;
        counters.forEach(counter => {
          const target = parseInt(counter.getAttribute('data-target'));
          animateCountUp(counter, target, 4000);
        });
        started = true;
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startCounters();
          }
        });
      }, {
        threshold: 0.3
      });

      const counterSection = document.querySelector('.counter_franchise');
      if (counterSection) {
        observer.observe(counterSection);
      }
    }); 
reportWebVitals();
